import { Component, Input, OnInit } from '@angular/core';
import { LandingService } from '../../../../api/landing.service';
import { TransactionService } from '../../../../api/transaction.service';
import saveAs from 'file-saver';
import { untilDestroyed } from '@ngneat/until-destroy';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
  selector: 'iv-download-invoice',
  templateUrl: './download-invoice.component.html',
  styleUrls: ['./download-invoice.component.scss']
})
export class DownloadInvoiceComponent implements ICellRendererAngularComp {
  rowData: any;
  @Input() invoiceData: any;

  constructor(
    private landingService: LandingService, 
    private transactionService: TransactionService
  ) { }

  agInit(params: ICellRendererParams<any, any, any>): void {
    this.rowData = params.data ? params.data : this.invoiceData;
  }

  refresh(params: ICellRendererParams<any, any, any>): boolean {
    return false;
  }

  downloadInvoice() {
    if (this.rowData['type']) {
      switch (this.rowData['type']) {
        case 'Document':
          this.downloadDocument(this.rowData);
          break;
        case 'Proforma':
        case 'FeeAdvisor':
          this.landingService.downloadProformaFeeAdvisor(this.rowData);
          break;
        default:
          this.landingService.downloadInvoice(this.rowData);
          break;
      }
    } else {
      this.landingService.downloadInvoice(this.rowData);
    }
  }

  downloadDocument(invoiceRow) {
    if (invoiceRow) {
      this.transactionService.downloadDocument(invoiceRow)
        .pipe(untilDestroyed(this))
        .subscribe(response => {
          saveAs(response, `${invoiceRow['file_name']}`);
        });
    }
  }
}

